// Investment-score badge for the Watch list tab. Numerical chip with
// real visual contrast across the buckets so the eye can scan the list
// and pick out call targets at a glance:
//   ≥70  bold brass-bright fill, dark text
//   50-69 medium-weight muted brass fill
//   <50  thin border, dim text — clearly filler
//   null  outlined "—"

interface ScoreBadgeProps {
  score: number | null;
}

export function ScoreBadge({ score }: ScoreBadgeProps) {
  if (score === null || score === undefined) {
    return (
      <span className="inline-flex items-center justify-center w-9 h-6 rounded border border-border text-text-faint text-[12px] font-mono">—</span>
    );
  }
  if (score >= 70) {
    return (
      <span className="inline-flex items-center justify-center w-9 h-6 rounded bg-accent text-bg text-[12px] font-mono font-bold tracking-wide">
        {score}
      </span>
    );
  }
  if (score >= 50) {
    return (
      <span className="inline-flex items-center justify-center w-9 h-6 rounded bg-accent/30 text-accent-bright text-[12px] font-mono font-medium">
        {score}
      </span>
    );
  }
  return (
    <span className="inline-flex items-center justify-center w-9 h-6 rounded border border-text-faint/30 text-text-faint text-[12px] font-mono font-light">
      {score}
    </span>
  );
}
